import { TypedUseSelectorHook, useDispatch as dispatch, useSelector as selector } from 'react-redux';

import { Dispatch } from 'store/configureStore';
import { RootReducer } from 'store/rootReducer';

export const useDispatch: () => Dispatch = dispatch;
export const useSelector: TypedUseSelectorHook<RootReducer> = selector;
